export enum FlourStockTypes {
  Munich,
  Nuremberg,
  Hechendorf,
  Salzburg,
  Munster = 6,
  Wien = 7,
}

export enum FlourStockTypesTranslations {
  Munich = 'München',
  Nuremberg = 'Nürnberg',
  Hechendorf = 'Hechendorf',
  Salzburg = 'Salzburg',
  Munster = 'Münster',
  Wien = 'Wien'
}
